// libs
import { useCallback, useState } from "react";

// contexts
import { PaymentLoaderContextValue, PaymentLoaderData } from "@payment-client/contexts/PaymentLoaderContext";

// constants
import { LOADER_TYPE } from "@payment-client/constants/Loader";

export const usePaymentLoader = (): PaymentLoaderContextValue => {
    const [isLoading, setIsLoading] = useState(false);
    const [loaderData, setLoaderdata] = useState<PaymentLoaderData>({
        type: LOADER_TYPE.MOVING_TRAY,
    });

    const setLoaderState = useCallback((state: boolean, loaderData?: PaymentLoaderData) => {
        setIsLoading(state);

        if (state) {
            setLoaderdata(
                loaderData ?? {
                    type: LOADER_TYPE.MOVING_TRAY,
                },
            );
        }
    }, []);

    return {
        isLoading,
        setLoaderState,
        loaderData,
    };
};
